

<ngx-sonner-toaster position="top-right" [richColors]="true" />
<router-outlet />
